<template>
  <div class="section_body">
    <div class="section_title">
      <h2>Source & Uses of Funds</h2>
    </div>
    <div class="tble-box">
      <div class="tbl-title">
        <h4>Source & Uses of Funds</h4>
      </div>
      <md-table v-model="changein" table-header-color="blue" class="dark_blue">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Change In:">
            {{
              item.title
            }}
          </md-table-cell>

          <!-- <md-table-cell md-label="Trend" class="table_chart">
            <chart-card
              header-animation="false"
              :chart-data="newChartChangeinOptions[item.name].data"
              :chart-options="chartOptions"
              chart-type="Line"
              header-icon
              chart-inside-content
              no-footer
              background-color="blue"
            ></chart-card>
          </md-table-cell> -->

          <!-- <md-table-cell
            v-for="key in Object.keys(item.dates)"
            :key="key + 'change'"
            :md-label="key"
          >{{ item.dates[key] }}</md-table-cell> -->

          <md-table-cell
            v-for="key in Object.keys(item.dates)"
            :key="key + 'change'"
            :md-label="(key === '19-' ? '19-20' : (key === '-21' ? '20-21' : key))"
          >{{ numberWithCommas(item.dates[key]) }}</md-table-cell>
          </md-table-row>
      </md-table>

      <!-- <md-table v-model="worksheet" table-header-color="blue" class="dark_blue">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Worksheet">
            {{
              item.title
            }}
          </md-table-cell>
          <md-table-cell
            v-for="key in Object.keys(item.dates)"
            :key="key + 'worksheet'"
            :md-label="key"
          >{{ item.dates[key] }}</md-table-cell>
        </md-table-row>
      </md-table> -->
    </div>
  </div>
</template>

<script>
// import { ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from "@/mixins/format-data";

export default {
  components: {
    // ChartCard,
    // IFReportHeader,
  },
  mixins: [formatData],
  props: ['headerInfo'],
  data() {
    return {
      changein: [],
      worksheet: [],
      newChartChangeinOptions: [],
      newChartWorksheetOptions: [],
      display_source_uses: false,
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
      filtered_years: []
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.report.data,
      sourcesUses: (state) => state.user.report ? state.user.report['sourcesUses'] : null,
      years: (state) => state.user.report.sourcesUses ? state.user.report['sourcesUses']['years'] : null,
      showYears: (state) => state.user.report.showYears,
      report: (state) => state.user.report,
    }),
    tablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    tablesInfo(newVal, oldVal) {
      if (newVal && this.years)
        Object.entries(this.tablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatData(table, data))
        );
    },
    years(newVal, oldVal) {
      if (this.showYears && newVal) {
        this.showYears.forEach((s, i) => {
          if (s && this.filtered_years) {
            this.filtered_years.push(this.years[i]);
          }
        });
      }
    },
    report(newVal, oldVal) {
        this.init();
    },
  },
  methods: {
    formatData(table, data) {
      let getDates = (id) =>
        this.years.reduce((acc, cur, index) => {
          let value = this.actualData[this.years.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    init() {
      if (this.report.displaySettings && this.report.displaySettings.includes('source_uses')) {
        this.display_source_uses = true;
      }

      if (this.tablesInfo && this.years)
        Object.entries(this.tablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatData(table, data))
        );

      let filtered_years = [];

      if (this.showYears && this.years) {
        this.showYears.forEach((s, i) => {
          if (s && filtered_years) {
            filtered_years.push(this.years[i]);
          }
        });
      }


      if (filtered_years && !filtered_years.length) {
        filtered_years = this.years;
      }

      this.changein = this.changein.concat(this.worksheet);

      this.changein = this.changein.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });

      this.changein.forEach(element => {
        this.newChartChangeinOptions[element.name] = {
          data: {
            labels: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]],
            series: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]]
          },
        }
      });
      this.worksheet = this.worksheet.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });
      this.worksheet.forEach(element => {
        this.newChartWorksheetOptions[element.name] = {
          data: {
            labels: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]],
            series: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]]
          },
        }
      });
      this.filtered_years = filtered_years;
    }
  },
};
</script>

